import axios from "axios";

const api = axios.create();

/** Upper bound on the token refresh a 401 triggers inside the interceptor. */
const REFRESH_TOKEN_TIMEOUT = 15000;

api.interceptors.request.use(
  (request) => {
    const token = localStorage.getItem("Token");
    if (token) {
      request.headers.Authorization = `Bearer ${token}`;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  async (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    // Optional chaining matters: a network error, a DNS failure or an axios
    // timeout (ECONNABORTED) carries no `response`, and dereferencing it here
    // replaced the real AxiosError with a TypeError before any caller saw it.
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const baseURL = process.env.REACT_APP_API_HOST;
      try {
        // Bounded on purpose: a per-request `timeout` only covers the
        // original call. Parking here instead leaves the caller's promise
        // unsettled forever, and a cached promise awaited by several
        // components hangs every one of them with no error and no retry.
        const refreshTokenResponse = await axios.post(
          `${baseURL}/Account/RefreshToken`,
          {
            TokenHash: localStorage.getItem("RefreshToken"),
            UserID: localStorage.getItem("UserID"),
          },
          { timeout: REFRESH_TOKEN_TIMEOUT }
        );
        if (refreshTokenResponse.data.error) {
          localStorage.setItem("Token", "end");
          return Promise.reject(refreshTokenResponse.data.error);
        } else {
          const newToken = refreshTokenResponse.data.tokenHash;
          localStorage.setItem("Token", newToken);
          originalRequest.headers.Authorization = `Bearer ${newToken}`;

          // Retry the original request with the new token
          return axios(originalRequest);
        }
      } catch (refreshError) {
        localStorage.setItem("Token", "end");
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;
